export const SET_ERROR_OBJECT = 'SET_ERROR_OBJECT';
